export default __webpack_public_path__ + "static/media/cholet3.88332b2f.jpg";